import * as React from 'react';
import theme from './theme.module.scss';
import useUserNotificationsManager from '../../../../hooks/useUserNotificationsManager';
import Notification from './Notification';
import {Icon} from '@vidazoo/ui-kit';
import {observer} from 'mobx-react';

function PanelBody(): React.JSX.Element {
    const manager = useUserNotificationsManager();
    const {items, isLoading, loadError, onSelectItem} = manager;

    const renderNoNotificationMessage = (): React.JSX.Element => {
        return (
            <div className={theme.notification}>
                <div className={theme.icon}>
                    <Icon iconName="icon-rejected-status" iconColor="var(--primary-text-color)" size={4}/>
                </div>
                <div className={theme.text}>
                    <div className={theme.subjectContainer}>
                        <div className={theme.subject}>{isLoading ? 'Loading notifications…' : loadError ? 'Unable to load notifications' : 'No notifications found'}</div>
                    </div>
                    {!isLoading && <div className={theme.message}>{loadError ? 'Please try again later' : 'We are sorry for the inconvenience'}</div>}
                </div>
            </div>
        );
    };

    return (
        <div className={theme.container}>
            <div className={theme.inner}>
                <div className={theme.notifications}>
                    {items.length ? items.map((notification) => (
                            <Notification
                                key={notification._id}
                                notification={notification}
                                onSelectItem={onSelectItem}
                            />
                        )) :
                        renderNoNotificationMessage()}
                </div>
            </div>
        </div>
    );
}

export default observer(PanelBody);
